import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress"; // ✅ MUI Loader
import BlogContent from "./BlogContent";
import BlogCard from "./BlogCard";

import {
  fetchBlogsByIDAsync,
  selectBlogById,
} from "../../../features/HomePage/homeSlice";


const BlogDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const blog = useSelector(selectBlogById);

  useEffect(() => {
    if (id) {
      dispatch(fetchBlogsByIDAsync(id));
    }
  }, [dispatch, id]);

  // ✅ Show MUI loader while blog is being fetched
  if (!blog) {
    return (
      <div className="w-full h-[60vh] flex items-center justify-center">
        <CircularProgress color="error" />
      </div>
    );
  }

  const {
    Title,
    CreatedAt,
    CategoryName,
    ManufactureName,
    UserFullName,
    keyContents,
    images,
    recommendations = [],
  } = blog;

  const bannerImage = images?.[0]
    ? `https://cyclecircle.blr1.cdn.digitaloceanspaces.com/${process.env.REACT_APP_IMAGE_BASE}_BLOGS_IMAGE/${images[0]}`
    : "";

  return (
    <div className="w-full my-6">
      {/* Breadcrumb */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <nav className="text-sm text-gray-500 flex flex-wrap gap-1">
          <Link to="/blog" className="hover:underline">
            Home
          </Link>
          <span className="mx-1">/</span>
          <span className="text-red-500 font-medium">{Title}</span>
        </nav>
      </div>

      {/* Title and Meta */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
        <div className="flex flex-col gap-3">
          <h1 className="text-2xl sm:text-3xl font-bold text-black-1">{Title}</h1>
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
            <div className="text-sm flex flex-wrap items-center gap-1 text-gray-600">
              <span className="text-red-500 font-medium">{UserFullName}</span>
              <span>-</span>
              <span>{new Date(CreatedAt)?.toLocaleDateString()}</span>
              <span>-</span>
              <span>5 min read</span>
            </div>
            <div className="flex flex-wrap gap-2">
              <span className="bg-[#e3e3e3] rounded-sm px-2 py-1 text-black-1 text-xs">
                {CategoryName}
              </span>
              <span className="bg-[#e3e3e3] rounded-sm px-2 py-1 text-black-1 text-xs">
                {ManufactureName}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Banner Image */}
      {bannerImage && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-4">
          <img
            src={bannerImage}
            alt={Title}
            className="w-full max-h-[400px] object-cover rounded-lg"
          />
        </div>
      )}

      {/* Blog Content */}
      <BlogContent sections={keyContents} />

      {/* Recommended Posts */}
      {recommendations?.length > 0 && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8">
          <h2 className="text-xl sm:text-2xl font-bold text-black-1 mb-4">
            Recommended Posts
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {recommendations?.map((item) => (
              <BlogCard key={item?.BlogID} post={item} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BlogDetail;
